import { useMemo, useState, useEffect } from 'react';
import { fetchProductsFromHandles } from '../../../../utilities';

import { ProductGroupOptionsOption } from './ProductGroupOptionsOption';

export function ProductGroupOptions({
  product,
  name = 'Color',
  selectedOptions,
  enabledGroupOptions,
  enabledGroupOptionsLink,
  productTypeForGroupOptions,
  disableGroupHistory,
  needsSelection,
  optionChanges,
  groupedBreadcrumbs,
}) {
  const optionsEnabled = enabledGroupOptions;
  const isProductTypePresent = productTypeForGroupOptions?.some(item => item?.productType === product?.productType);

  const [groupingProductsMapByColor, setGroupingProductsMapByColor] =
    useState(null);
  const [selectedTab, setSelectedTab] = useState(null);

  const colorOptions = useMemo(() => {
    return product?.grouping?.isTransformed
      ? product?.grouping?.options?.find((option) => option?.name === 'Color')
      : product?.options?.find((option) => option?.name === 'Color');
  }, [product]);

  const selectedColor = selectedOptions?.[name];

  const validGroups = colorOptions?.groups?.filter(group => group?.values?.length > 0);

  const renderOptions = (group, index) => {
    const groupHasSelectedColor = group?.values?.includes(selectedColor);
    const groupName = group?.name === 'Default' ? 'Solids' : group?.name;
    const colorName = groupName?.toLowerCase().trim().endsWith('colors')
      ? groupName
      : `${groupName}`;

    return (
      <ProductGroupOptionsOption
        key={index}
        name={colorName}
        groupingProductsMapByColor={groupingProductsMapByColor}
        groupValues={group?.values}
        selectedOptions={selectedOptions}
        selectedValue={groupHasSelectedColor ? selectedColor : null}
        selectedColor={selectedColor}
        optionsEnabled={optionsEnabled}
        optionsLinkEnabled={enabledGroupOptionsLink}
        disableGroupHistory={disableGroupHistory}
        needsSelection={needsSelection}
        optionChanges={optionChanges}
        isProductTypePresent={isProductTypePresent}
        index={index}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        isColor={true}
        groupedBreadcrumbs={groupedBreadcrumbs}
      />
    );
  };

  useEffect(() => {
    if (!product?.grouping?.isTransformed) return;

    const fetchProductsForMap = async () => {
      let productHandles = product?.grouping?.products || [];
      if (product?.grouping?.subgroups?.length) {
        product?.grouping?.subgroups?.forEach((subgroup) => {
          productHandles = [...productHandles, ...subgroup.products];
        });
      }
      const products = await fetchProductsFromHandles(productHandles);
      setGroupingProductsMapByColor(
        products?.reduce((acc, groupProduct) => {
          const color = groupProduct?.optionsMap?.Color?.[0];
          if (!color) return acc;
          return {
            ...acc,
            [color]: groupProduct,
          };
        }, {})
      );
    };
    fetchProductsForMap();
  }, [product?.id]);
  
  return optionsEnabled && isProductTypePresent ? (
    <div className="w-full">
      <div className="mb-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-label text-darkGray">Inseam /Style</h3>
        </div>
      </div>
      <ul className="flex flex-wrap gap-[5px]" aria-label="Color Options" role="tablist">
        {validGroups?.map(renderOptions)}
      </ul>
    </div>
  ) : (
    <div className="mb-2 flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">

      </div>
    </div>
  );
}

ProductGroupOptions.displayName = 'ProductGroupOptions';
